import React, { useState, useEffect, useRef } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { getDatabase, ref, onValue, set } from "firebase/database";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faTimes, faCheck, faTimesCircle, faCheckCircle, 
  faEnvelope, faMapMarkerAlt, faClock, faEye, 
  faStar, faRupeeSign, faSearch, faFilePdf
} from '@fortawesome/free-solid-svg-icons';
import { faStar as faStarRegular } from '@fortawesome/free-regular-svg-icons';
import { jsPDF } from "jspdf";
// import logo from '../../assets/logo.png';
import logo1 from '../../assets/image1.jpg';

const EnquiryForm = ({ onClose, tour }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    mobile: '',
    travellers: '',
    date: '',
    destination: tour?.destination || '',
    tourName: tour?.name || ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const database = getDatabase();
      const enquiryRef = ref(database, `enquiry/${formData.mobile}`);
      await set(enquiryRef, {
        ...formData,
        status: 'pending',
        timestamp: new Date().toISOString()
      });
      alert('Enquiry submitted successfully!');
      onClose();
    } catch (error) {
      console.error('Error submitting enquiry:', error);
      alert('Failed to submit enquiry. Please try again.');
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container enquiry-modal" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close-btn" onClick={onClose}>
          <FontAwesomeIcon icon={faTimes} />
        </button>
        
        <div className="modal-header">
          <h2>Plan Your Dream Vacation</h2>
          <p className="subtitle">Fill out the form below and our travel experts will get back to you within 24 hours</p>
        </div>

        <form onSubmit={handleSubmit} className="enquiry-form">
          <div className="form-group">
            <label>Full Name*</label>
            <input 
              type="text" 
              name="name" 
              value={formData.name} 
              onChange={handleChange} 
              required 
              placeholder="Enter your full name"
            />
          </div>

          <div className="form-group">
            <label>Email Address*</label>
            <input 
              type="email" 
              name="email" 
              value={formData.email} 
              onChange={handleChange} 
              required 
              placeholder="Enter your email"
            />
          </div>

          <div className="form-group">
            <label>Mobile Number*</label>
            <input 
              type="tel" 
              name="mobile" 
              value={formData.mobile} 
              onChange={handleChange} 
              required 
              placeholder="Enter 10-digit mobile number"
            />
          </div>

          <div className="form-group">
            <label>Number of Travellers*</label>
            <input 
              type="number" 
              name="travellers" 
              value={formData.travellers} 
              onChange={handleChange} 
              required 
              placeholder="How many people?"
              min="1"
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Preferred Travel Date*</label>
              <input 
                type="date" 
                name="date" 
                value={formData.date} 
                onChange={handleChange} 
                required 
              />
            </div>

            <div className="form-group">
              <label>Destination*</label>
              <input 
                type="text" 
                name="destination" 
                value={formData.destination} 
                onChange={handleChange} 
                required 
                readOnly
                className="read-only"
              />
            </div>
          </div>

          <div className="form-group">
            <label>Tour Package</label>
            <input 
              type="text" 
              name="tourName" 
              value={formData.tourName} 
              onChange={handleChange} 
              readOnly
              className="read-only"
            />
          </div>

          <button type="submit" className="submit-btn">
            Submit Enquiry
            <FontAwesomeIcon icon={faEnvelope} className="btn-icon" />
          </button>
        </form>
      </div>
    </div>
  );
};

const TourDetailsModal = ({ tour, onClose }) => {
  const [showEnquiryForm, setShowEnquiryForm] = useState(false);
  const [activeImage, setActiveImage] = useState(0);

  const generatePDF = async () => {
    if (!tour) return;

    try {
      const doc = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4"
      });

      let yPosition = 10;

      // Add logo
      const img = new Image();
      img.src = logo1;
      await new Promise(resolve => img.onload = resolve);

      const logoWidth = 200;
      const logoHeight = 100;
      const centerX = 105 - logoWidth / 2;
      doc.addImage(img, 'PNG', centerX, yPosition, logoWidth, logoHeight);
      yPosition += logoHeight + 5;

      // Add company info
     

      // Add package name
      doc.setFontSize(18);
      doc.setTextColor(30, 58, 138);
      doc.setFont("helvetica", "bold");
      doc.text(`${tour.name.toUpperCase()}`, 20, yPosition);
      yPosition += 10;

      // Add package details
      doc.setFontSize(12);
      doc.setTextColor(80, 80, 80);
      doc.setFont("helvetica", "normal");
      doc.text(`Destination: ${tour.destination}`, 20, yPosition);
      yPosition += 7;
      doc.text(`Duration: ${tour.duration}`, 20, yPosition);
      yPosition += 7;
    



    // ======================
    // 🔹 UPDATED PRICE SECTION
    // ======================
    doc.setFontSize(12);
    doc.setTextColor(30, 58, 138);
    doc.setFont("helvetica", "bold");
    doc.text("PRICE DETAILS", 20, yPosition);
    yPosition += 7;

    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");

    const extractNumbers = (str) => {
      if (typeof str === "number") return str;
      const numMatch = str?.toString().match(/\d+(\.\d+)?/g);
      if (numMatch) {
        const numStr = numMatch[0].replace(/,/g, "");
        return parseFloat(numStr);
      }
      return 0;
    };

    if (
      tour.priceValues &&
      typeof tour.priceValues === "object" &&
      Object.keys(tour.priceValues).length > 0
    ) {
      doc.setFillColor(241, 243, 245);
      doc.rect(15, yPosition, 180, 8, "F");

      doc.setFontSize(10);
      doc.setTextColor(30, 58, 138);
      doc.text("Price Breakdown", 20, yPosition + 6);
      yPosition += 15;

      Object.entries(tour.priceValues).forEach(([priceType, priceValue]) => {
        const numericValue = extractNumbers(priceValue);
        const discountedValue = Math.max(0, numericValue - 2000);

        const discountedText = priceValue.replace(
          numericValue.toString(),
          discountedValue.toString()
        );

        doc.setTextColor(30, 58, 138);
        doc.text(discountedText, 20, yPosition);

        yPosition += 10;
        if (yPosition > 267) {
          doc.addPage();
          yPosition = 20;
        }
      });

      if (tour.totalPrice) {
        doc.setFont("helvetica", "bold");
        doc.text(`Total Package Price: ${tour.totalPrice}`, 20, yPosition);

        const totalNumeric = extractNumbers(tour.totalPrice);
        const discountedTotal = Math.max(0, totalNumeric - 2000);
        const formattedDiscountedTotal = `₹${discountedTotal.toLocaleString("en-IN")}`;

        doc.setTextColor(30, 58, 138);
        doc.text(`Discounted Total: ${formattedDiscountedTotal}`, 20, yPosition + 8);

        yPosition += 16;
      }
    } else if (tour.discountedPrice) {
      doc.text(`Price: ₹${tour.originalPrice?.toLocaleString("en-IN")}`, 20, yPosition);

      const discountedPrice = Math.max(0, tour.originalPrice - 2000);
      const formattedDiscountedPrice = `₹${discountedPrice.toLocaleString("en-IN")}`;

      doc.setTextColor(30, 58, 138);
      doc.text(`Discounted Price: ${formattedDiscountedPrice}`, 20, yPosition + 8);

      yPosition += 16;
    } else {
      doc.text("No pricing information available", 20, yPosition);
      yPosition += 7;
    }

    yPosition += 10;






      // Add description
      doc.setFontSize(14);
      doc.setTextColor(30, 58, 138);
      doc.setFont("helvetica", "bold");
      doc.text("DESCRIPTION", 20, yPosition);
      yPosition += 10;

      doc.setFontSize(12);
      doc.setTextColor(50, 50, 50);
      const description = tour.description || "No description available";
      const descriptionLines = doc.splitTextToSize(description, 170);
      descriptionLines.forEach(line => {
        if (yPosition > 267) {
          doc.addPage();
          yPosition = 20;
        }
        doc.text(line, 20, yPosition);
        yPosition += 6;
      });
      yPosition += 10;

      // Add itinerary
      doc.addPage();
      yPosition = 20;
      doc.setFontSize(16);
      doc.setTextColor(30, 58, 138);
      doc.setFont("helvetica", "bold");
      doc.text("DETAILED ITINERARY", 105, yPosition, { align: "center" });
      yPosition += 10;

      if (tour.itinerary && typeof tour.itinerary === "object") {
        Object.entries(tour.itinerary).forEach(([dayTitle, activities], index) => {
          if (yPosition > 267) {
            doc.addPage();
            yPosition = 20;
          }

          doc.setFillColor(241, 243, 245);
          doc.rect(15, yPosition, 180, 8, 'F');
          doc.setFontSize(14);
          doc.setTextColor(30, 58, 138);
          doc.text(dayTitle, 20, yPosition + 6);
          yPosition += 10;

          yPosition += 5;

          doc.setFontSize(12);
          doc.setTextColor(50, 50, 50);
          const descText = typeof activities === 'object' ? activities.description || '' : activities;
          const descLines = doc.splitTextToSize(descText, 170);
          descLines.forEach(line => {
            if (yPosition > 267) {
              doc.addPage();
              yPosition = 20;
            }
            doc.text(line, 20, yPosition);
            yPosition += 6;
          });
          yPosition += 5;
        });
      } else {
        doc.text("No detailed itinerary available.", 20, yPosition);
        yPosition += 10;
      }

      // Add inclusions
      doc.addPage();
      yPosition = 20;
      doc.setFontSize(16);
      doc.setTextColor(30, 58, 138);
      doc.setFont("helvetica", "bold");
      doc.text("INCLUSIONS", 20, yPosition);
      yPosition += 10;

      doc.setFontSize(12);
      doc.setFont("helvetica", "normal");
      if (tour.includes && typeof tour.includes === 'object') {
        Object.values(tour.includes).forEach((item) => {
          if (yPosition > 267) {
            doc.addPage();
            yPosition = 20;
          }
          doc.text(`• ${item}`, 25, yPosition);
          yPosition += 7;
        });
      } else {
        doc.text("No inclusions listed.", 25, yPosition);
        yPosition += 7;
      }

      // Add exclusions
      yPosition += 10;
      doc.setFontSize(16);
      doc.setTextColor(30, 58, 138);
      doc.setFont("helvetica", "bold");
      doc.text("EXCLUSIONS", 20, yPosition);
      yPosition += 10;

      doc.setFontSize(12);
      doc.setFont("helvetica", "normal");
      if (tour.excludes && typeof tour.excludes === 'object') {
        Object.values(tour.excludes).forEach((item) => {
          if (yPosition > 267) {
            doc.addPage();
            yPosition = 20;
          }
          doc.text(`• ${item}`, 25, yPosition);
          yPosition += 7;
        });
      } else {
        doc.text("No exclusions listed.", 25, yPosition);
        yPosition += 7;
      }

      // Add footer to all pages
      const pageCount = doc.internal.getNumberOfPages();
      const footerY = 287;
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setDrawColor(200, 200, 200);
        doc.setLineWidth(0.3);
        doc.line(15, footerY - 5, 195, footerY - 5);
        doc.setFontSize(10);
        doc.setTextColor(100, 100, 100);
        doc.text(`Page ${i} of ${pageCount}`, 105, footerY, { align: "center" });
        doc.text("Pearl Tours & Travels", 20, footerY);
        doc.text(new Date().toLocaleDateString(), 190, footerY, { align: "right" });
      }

      // Save the PDF
      const fileName = `${(tour.name || 'tour').replace(/\s+/g, '_')}_package_details.pdf`;
      doc.save(fileName);
    } catch (error) {
      console.error('Error generating PDF:', error);
      alert('Failed to generate PDF. Please try again.');
    }
  };

  if (!tour) return null;

  return (
    <>
      <div className="modal-overlay" onClick={(e) => {
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}>
        <div className="modal-container tour-modal">
          <button className="modal-close-btn" onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
          
          <div className="modal-header">
            <h2>{tour.name}</h2>
            <div className="modal-subheader">
              <span className="modal-location">
                <FontAwesomeIcon icon={faMapMarkerAlt} /> {tour.destination}
              </span>
              <span className="modal-duration">
                <FontAwesomeIcon icon={faClock} /> {tour.duration}
              </span>
              <span className="modal-rating">
                {[...Array(5)].map((_, i) => (
                  <FontAwesomeIcon 
                    key={i} 
                    icon={i < (tour.rating || 5) ? faStar : faStarRegular} 
                    className={i < (tour.rating || 5) ? "filled" : ""}
                  />
                ))}
                <span>({tour.rating || 5}.0)</span>
              </span>
            </div>
          </div>
          
          <div className="modal-image-gallery">
            <div className="main-image">
              <img 
                src={tour.images?.[activeImage] || "https://via.placeholder.com/800x500?text=No+Image"} 
                alt={tour.name} 
                className="zoom-on-hover"
              />
              {tour.bestSelling && <span className="best-seller-badge">BEST SELLER</span>}
            </div>
            <div className="thumbnail-container">
              {(tour.images || []).slice(0, 4).map((img, index) => (
                <div 
                  key={index} 
                  className={`thumbnail ${index === activeImage ? 'active' : ''}`}
                  onClick={() => setActiveImage(index)}
                >
                  <img src={img} alt={`${tour.name} ${index + 1}`} />
                </div>
              ))}
            </div>
          </div>
          
          <div className="modal-content">
            <div className="modal-price-section">
              <div className="price-box">
                <div className="price-header">
                  <span className="price-label">Starting from</span>
                  <div className="price-amount">
                    <FontAwesomeIcon icon={faRupeeSign} className="rupee-icon" />
                    {(tour.discountedPrice)?.toLocaleString() || "0"}
                  </div>
                  <span className="price-per">per person</span>
                </div>
                
                <button 
                  className="download-pdf-btn"
                  onClick={generatePDF}
                >
                  <FontAwesomeIcon icon={faFilePdf} className="btn-icon" /> 
                  Download PDF
                </button>
                
                <button 
                  className="enquiry-now-btn"
                  onClick={() => setShowEnquiryForm(true)}
                >
                  <FontAwesomeIcon icon={faEnvelope} className="btn-icon" /> 
                  Enquire Now
                </button>
                
                {/* <div className="offer-banner">
                  <span className="offer-tag">Special Offer</span>
                  <p>Book now and get 10% discount on your first booking!</p>
                </div> */}
              </div>
            </div>
            
            <div className="modal-details-section">
              <div className="section-block">
                <h3>Overview</h3>
                <p className="tour-description">{tour.description}</p>
              </div>
              
              <div className="section-block">
                <h3>Package Highlights</h3>
                <ul className="highlights-list">
                  {(tour.highlights || []).map((item, index) => (
                    <li key={index}>
                      <FontAwesomeIcon icon={faCheckCircle} className="highlight-icon" /> 
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
              
              <div className="section-block">
                <h3>Detailed Itinerary</h3>
                <div className="itinerary">
                  {tour.itinerary && typeof tour.itinerary === "object" ? (
                    Object.entries(tour.itinerary).map(([dayTitle, description], index) => (
                      <div key={index} className="day-plan">
                        <h4>{dayTitle}</h4>
                        <p>{description}</p>
                      </div>
                    ))
                  ) : (
                    <p className="no-itinerary">Detailed itinerary coming soon</p>
                  )}
                </div>
              </div>

              <div className="inclusion-exclusion">
                <div className="inclusions">
                  <h3>Inclusions</h3>
                  <ul className="inclusions-list">
                    {tour.includes && typeof tour.includes === 'object' ? (
                      Object.values(tour.includes).map((item, index) => (
                        <li key={index}>
                          <FontAwesomeIcon icon={faCheck} className="inclusion-icon" /> 
                          <span>{item}</span>
                        </li>
                      ))
                    ) : (
                      <li className="no-data">No inclusions listed</li>
                    )}
                  </ul>
                </div>

                <div className="exclusions">
                  <h3>Exclusions</h3>
                  <ul className="exclusions-list">
                    {tour.excludes && typeof tour.excludes === 'object' ? (
                      Object.values(tour.excludes).map((item, index) => (
                        <li key={index}>
                          <FontAwesomeIcon icon={faTimes} className="exclusion-icon" /> 
                          <span>{item}</span>
                        </li>
                      ))
                    ) : (
                      <li className="no-data">No exclusions listed</li>
                    )}
                  </ul>
                </div>
              </div>

              {tour.termsAndConditions && (
                <div className="section-block terms-conditions">
                  <h3>Terms & Conditions</h3>
                  <p className="terms">{tour.termsAndConditions}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {showEnquiryForm && (
        <EnquiryForm 
          onClose={() => setShowEnquiryForm(false)} 
          tour={tour}
        />
      )}
    </>
  );
};

export default function AgentDomestics() {
  const [allPackages, setAllPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedTour, setSelectedTour] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");

  // useEffect(() => {
  //   const database = getDatabase();
  //   const packagesRef = ref(database, "AgentPackages/domestic");

  //   const unsubscribe = onValue(packagesRef, (snapshot) => {
  //     const data = snapshot.val();
  //     const packagesArray = [];

  //     if (data) {
  //       Object.keys(data).forEach((country) => {
  //         Object.keys(data[country]).forEach((packageName) => {
  //           const pkg = data[country][packageName];

  //           if (pkg.type === "domestic") {
  //             packagesArray.push({
  //               id: `${country}-${packageName}`,
  //               ...pkg,
  //               discountedPrice: pkg.price - 0
  //             });
  //           }
  //         });
  //       });
  //     }

  //     setAllPackages(packagesArray);
  //     setLoading(false);
  //   });

  //   return () => unsubscribe();
  // }, []);







  useEffect(() => {
  const database = getDatabase();
  const packagesRef = ref(database, "AgentPackages/domestic");

  const unsubscribe = onValue(packagesRef, (snapshot) => {
    const data = snapshot.val();
    const packagesArray = [];

    if (data) {
      Object.keys(data).forEach((country) => {
        Object.keys(data[country]).forEach((packageName) => {
          const pkg = data[country][packageName];

          if (pkg.type === "domestic") {
            // Extract price from priceValues or price field
            let priceString = "";
            
            // Check priceValues first
            if (pkg.priceValues) {
              if (Array.isArray(pkg.priceValues)) {
                priceString = pkg.priceValues[0] || "";
              } else if (typeof pkg.priceValues === "object") {
                const priceValuesArray = Object.values(pkg.priceValues);
                if (priceValuesArray.length > 0) {
                  priceString = priceValuesArray[0] || "";
                }
              } else if (typeof pkg.priceValues === "string") {
                priceString = pkg.priceValues;
              }
            } 
            // Fallback to price field if priceValues is not available
            else if (pkg.price) {
              priceString = pkg.price;
            }
            
            // Extract the INR price from the string
            let numericPrice = 0;
            if (priceString) {
              // Match format: "INR.56,800" or "INR 56,800" or "INR: 56,800"
              const priceMatch = priceString.match(/INR[.:]?\s*(\d{1,3}(?:,\d{3})*)/i);
              
              if (priceMatch && priceMatch[1]) {
                // Remove commas and convert to number (e.g., "56,800" -> 56800)
                numericPrice = parseInt(priceMatch[1].replace(/,/g, '')) || 0;
              } else {
                // Fallback: extract all digits from the string
                const digitsOnly = priceString.replace(/\D/g, '');
                numericPrice = parseInt(digitsOnly) || 0;
              }
            }

            // Discount calculation (keeping the existing logic)
            const discountedPrice = Math.max(0, numericPrice - 2000);

            packagesArray.push({
              id: `${country}-${packageName}`,
              ...pkg,
              originalPrice: numericPrice,
              discountedPrice,
              // Store the original price string for reference
              originalPriceString: priceString || ""
            });
          }
        });
      });
    }

    setAllPackages(packagesArray);
    setLoading(false);
  });

  return () => unsubscribe();
}, []);




  const filteredPackages = allPackages.filter(pkg => 
    pkg.name.toLowerCase().includes(searchQuery.toLowerCase()) || 
    pkg.destination.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const TourCard = ({ tour }) => (
    <div className="card" onClick={() => setSelectedTour(tour)}>
      <div className="card-image-container">
        {tour.bestSelling && <span className="best-seller-badge">BEST SELLER</span>}
        <img
          src={tour.images?.[0] || "https://via.placeholder.com/300x200?text=No+Image"}
          alt={tour.name}
          className="card-image zoom-on-hover"
        />
        <div className="location-tag">
          <FontAwesomeIcon icon={faMapMarkerAlt} /> {tour.destination}
        </div>
      </div>
      <div className="card-content">
        <div className="card-header">
          <h2 className="card-title">{tour.name}</h2>
          <div className="card-duration">
            <FontAwesomeIcon icon={faClock} /> {tour.duration}
          </div>
        </div>
        
        <div className="card-highlights">
          <p>{tour.description?.split(" ").slice(0, 20).join(" ")}...</p>
        </div>
        
        <div className="card-footer">
          <div className="price-section">
            <div className="discounted-price">
              <FontAwesomeIcon icon={faRupeeSign} className="rupee-icon" />
              {(tour.discountedPrice - 0)?.toLocaleString() || "0"}
            </div>
          </div>
          
          <div className="rating-section">
            <div className="stars">
              {[...Array(5)].map((_, i) => (
                <FontAwesomeIcon 
                  key={i} 
                  icon={i < (tour.rating || 5) ? faStar : faStarRegular} 
                  className={i < (tour.rating || 5) ? "filled" : ""}
                />
              ))}
            </div>
            <span className="rating-text">({tour.rating || 5}.0)</span>
          </div>
          
          <button className="view-btn">
            <FontAwesomeIcon icon={faEye} /> View Details
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <Navbar />
      <style jsx>{`
        /* ... (keep all your existing styles) ... */
        :root {
          --primary: #4a6bff;
          --primary-dark: #3a56d4;
          --primary-light: #eef1ff;
          --secondary: #ff7e33;
          --secondary-light: #fff0e8;
          --accent: #00c9a7;
          --dark: #2d3748;
          --dark-gray: #4a5568;
          --medium-gray: #718096;
          --light-gray: #edf2f7;
          --lighter-gray: #f7fafc;
          --white: #ffffff;
          --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.1);
          --shadow-md: 0 4px 6px rgba(0, 0, 0, 0.1);
          --shadow-lg: 0 10px 25px rgba(0, 0, 0, 0.1);
          --shadow-xl: 0 20px 40px rgba(0, 0, 0, 0.15);
          --transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
        }

        * {
          box-sizing: border-box;
          margin: 0;
          padding: 0;
          font-family: 'Poppins', sans-serif;
        }

        body {
          background-color: var(--lighter-gray);
          color: var(--dark);
          line-height: 1.6;
        }

        .container {
          max-width: 100%;
          margin: 0 auto;
          padding: 2rem 1rem;
        }

        .hero-section {
          {/* background: linear-gradient(135deg, var(--primary) 0%, var(--primary-dark) 100%); */}
          color: var(--white);
          padding: 4rem 2rem;
          {/* border-radius: 12px; */}
          margin-bottom: 3rem;
          text-align: center;
          position: relative;
          overflow: hidden;
        }

        .hero-section::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: url('https://images.unsplash.com/photo-1506929562872-bb421503ef21?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80') center/cover;
          opacity: 1;
          z-index: 0;
        }

        .hero-content {
          position: relative;
          z-index: 1;
          max-width: 800px;
          margin: 0 auto;
        }

        .title {
          font-size: 2.8rem;
          font-weight: 700;
          margin-bottom: 1rem;
          background: linear-gradient(to right, var(--white), #e0e7ff);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .subtitle {
          font-size: 1.2rem;
          opacity: 0.9;
          margin-bottom: 2rem;
        }

        .search-container {
          max-width: 700px;
          margin: 0 auto;
          width: 100%;
          position: relative;
        }

        .search-box {
          display: flex;
          border-radius: 50px;
          overflow: hidden;
          box-shadow: var(--shadow-xl);
          transition: var(--transition);
        }

        .search-box input {
          flex: 1;
          padding: 1.2rem 1.5rem;
          border: none;
          font-size: 1rem;
          background: var(--white);
          color: var(--dark);
        }

        .search-box input::placeholder {
          color: var(--medium-gray);
        }

        .search-box input:focus {
          outline: none;
        }

        .search-box button {
          padding: 0 2rem;
          background: var(--secondary);
          color: var(--white);
          border: none;
          font-weight: 600;
          font-size: 1rem;
          cursor: pointer;
          transition: var(--transition);
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }

        .search-box button:hover {
          background: #ff6a1a;
        }

        .cards-container {
          width: 100%;
        }

        .cards {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
          gap: 2rem;
          margin-bottom: 2rem;
        }

        /* Tour Card */
        .card {
          background: var(--white);
          border-radius: 12px;
          overflow: hidden;
          box-shadow: var(--shadow-md);
          transition: var(--transition);
          position: relative;
          cursor: pointer;
        }

        .card:hover {
          transform: translateY(-5px);
          box-shadow: var(--shadow-xl);
        }

        .card-image-container {
          position: relative;
          height: 220px;
          overflow: hidden;
        }

        .card-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: var(--transition);
        }

        .zoom-on-hover {
          transition: transform 0.5s ease;
        }

        .zoom-on-hover:hover {
          transform: scale(1.05);
        }

        .best-seller-badge {
          position: absolute;
          top: 1rem;
          left: 1rem;
          background: var(--secondary);
          color: var(--white);
          padding: 0.3rem 1rem;
          border-radius: 20px;
          font-size: 0.8rem;
          font-weight: 600;
          z-index: 1;
          text-transform: uppercase;
          letter-spacing: 1px;
        }

        .location-tag {
          position: absolute;
          bottom: 1rem;
          left: 1rem;
          background: rgba(0, 0, 0, 0.7);
          color: var(--white);
          padding: 0.5rem 1rem;
          border-radius: 20px;
          font-size: 0.9rem;
          display: flex;
          align-items: center;
          gap: 0.5rem;
          z-index: 1;
        }

        .card-content {
          padding: 1.5rem;
          display: flex;
          flex-direction: column;
          height: calc(100% - 220px);
        }

        .card-header {
          margin-bottom: 1rem;
        }

        .card-title {
          font-size: 1.3rem;
          color: var(--dark);
          margin-bottom: 0.5rem;
          font-weight: 600;
        }

        .card-duration {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          font-size: 0.9rem;
          color: var(--medium-gray);
        }

        .card-highlights {
          margin-bottom: 1.5rem;
          flex-grow: 1;
        }

        .card-highlights p {
          font-size: 0.95rem;
          color: var(--dark-gray);
          line-height: 1.6;
        }

        .card-footer {
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }

        .price-section {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          flex-wrap: wrap;
        }

        .discounted-price {
          font-size: 1.5rem;
          font-weight: 700;
          color: var(--primary);
          display: flex;
          align-items: center;
        }

        .rupee-icon {
          font-size: 1rem;
          margin-right: 2px;
        }

        .original-price {
          font-size: 0.9rem;
          color: var(--medium-gray);
        }

        .original-price span {
          text-decoration: line-through;
        }

        .save-badge {
          background: var(--primary-light);
          color: var(--primary);
          padding: 0.2rem 0.6rem;
          border-radius: 4px;
          font-size: 0.8rem;
          font-weight: 600;
        }

        .rating-section {
          display: flex;
          align-items: center;
          gap: 0.3rem;
        }

        .stars {
          color: #ffc107;
        }

        .stars .filled {
          color: #ffc107;
        }

        .rating-text {
          font-size: 0.9rem;
          color: var(--medium-gray);
        }

        .view-btn {
          width: 100%;
          padding: 0.8rem;
          border-radius: 6px;
          font-weight: 600;
          cursor: pointer;
          transition: var(--transition);
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.5rem;
          font-size: 0.95rem;
          background: var(--primary);
          color: var(--white);
          border: none;
        }

        .view-btn:hover {
          background: var(--primary-dark);
        }

        /* Loading Spinner */
        .loading-container {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 300px;
        }

        .spinner {
          width: 50px;
          height: 50px;
          border: 5px solid rgba(74, 107, 255, 0.1);
          border-radius: 50%;
          border-top-color: var(--primary);
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }

        /* No Results */
        .no-results {
          text-align: center;
          padding: 3rem;
          background: var(--white);
          border-radius: 10px;
          box-shadow: var(--shadow-sm);
          grid-column: 1 / -1;
        }

        .no-results i {
          font-size: 3rem;
          margin-bottom: 1rem;
          color: var(--light-gray);
        }

        .no-results h3 {
          color: var(--dark);
          margin-bottom: 0.5rem;
        }

        .no-results p {
          color: var(--medium-gray);
          margin-bottom: 1.5rem;
        }

        /* Modal Styles */
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.7);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
          padding: 2rem;
          overflow-y: auto;
          animation: fadeIn 0.3s ease;
        }

        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        .modal-container {
          background: var(--white);
          border-radius: 12px;
          width: 100%;
          max-width: 1200px;
          max-height: 90vh;
          overflow-y: auto;
          box-shadow: var(--shadow-xl);
          position: relative;
          animation: slideUp 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
        }

        @keyframes slideUp {
          from { transform: translateY(20px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }

        .modal-close-btn {
          position: absolute;
          top: 1rem;
          right: 1rem;
          background: rgba(0, 0, 0, 0.1);
          border: none;
          width: 36px;
          height: 36px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1rem;
          color: var(--dark);
          cursor: pointer;
          transition: var(--transition);
          z-index: 10;
        }

        .modal-close-btn:hover {
          background: rgba(0, 0, 0, 0.2);
        }

        .modal-header {
          padding: 2rem 2rem 1rem;
        }

        .modal-header h2 {
          color: var(--dark);
          margin-bottom: 0.5rem;
          font-size: 1.8rem;
        }

        .modal-subheader {
          display: flex;
          gap: 1.5rem;
          flex-wrap: wrap;
          color: var(--medium-gray);
          font-size: 0.95rem;
          margin-bottom: 1rem;
        }

        .modal-subheader span {
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }

        .modal-image-gallery {
          display: grid;
          grid-template-columns: 1fr;
          gap: 1rem;
          padding: 0 2rem;
          margin-top: 1rem;
        }

        .main-image {
          width: 100%;
          height: 400px;
          border-radius: 8px;
          overflow: hidden;
          position: relative;
        }

        .main-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .thumbnail-container {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 1rem;
        }

        .thumbnail {
          height: 80px;
          border-radius: 5px;
          overflow: hidden;
          cursor: pointer;
          transition: var(--transition);
          position: relative;
          border: 2px solid transparent;
        }

        .thumbnail:hover {
          transform: translateY(-3px);
          box-shadow: var(--shadow-md);
        }

        .thumbnail.active {
          border-color: var(--primary);
        }

        .thumbnail img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .modal-content {
          display: grid;
          grid-template-columns: 1fr 300px;
          gap: 2rem;
          padding: 2rem;
        }

        .modal-price-section {
          position: sticky;
          top: 1rem;
          height: fit-content;
        }

        .price-box {
          background: var(--lighter-gray);
          border-radius: 10px;
          padding: 1.5rem;
          box-shadow: var(--shadow-sm);
          border: 1px solid var(--light-gray);
        }

        .price-header {
          text-align: center;
          margin-bottom: 1rem;
        }

        .price-label {
          display: block;
          font-size: 0.9rem;
          color: var(--medium-gray);
          margin-bottom: 0.5rem;
        }

        .price-amount {
          font-size: 2rem;
          font-weight: 700;
          color: var(--primary);
          display: flex;
          align-items: center;
          justify-content: center;
          line-height: 1;
          margin-bottom: 0.5rem;
        }

        .price-amount .rupee-icon {
          font-size: 1.5rem;
          margin-right: 5px;
        }

        .price-per {
          display: block;
          font-size: 0.9rem;
          color: var(--medium-gray);
          margin-bottom: 1.5rem;
        }

        .price-details {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 1.5rem;
          padding-bottom: 1.5rem;
          border-bottom: 1px dashed var(--light-gray);
        }

        .original-price {
          font-size: 0.9rem;
          color: var(--medium-gray);
        }

        .strikethrough {
          text-decoration: line-through;
        }

        .discount-badge {
          background: var(--secondary-light);
          color: var(--secondary);
          padding: 0.3rem 0.8rem;
          border-radius: 20px;
          font-size: 0.8rem;
          font-weight: 600;
        }

        .enquiry-now-btn {
          width: 100%;
          padding: 1rem;
          background: var(--primary);
          color: var(--white);
          border: none;
          border-radius: 6px;
          font-weight: 600;
          cursor: pointer;
          transition: var(--transition);
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.5rem;
          margin-bottom: 1.5rem;
        }

        .enquiry-now-btn:hover {
          background: var(--primary-dark);
        }

        .btn-icon {
          font-size: 0.9rem;
        }

        .offer-banner {
          background: var(--primary-light);
          border-radius: 8px;
          padding: 1rem;
          text-align: center;
        }

        .offer-tag {
          display: inline-block;
          background: var(--primary);
          color: var(--white);
          padding: 0.2rem 0.8rem;
          border-radius: 20px;
          font-size: 0.8rem;
          font-weight: 600;
          margin-bottom: 0.5rem;
        }

        .offer-banner p {
          font-size: 0.9rem;
          color: var(--dark);
          margin: 0;
        }

        .modal-details-section {
          padding-right: 1rem;
        }

        .section-block {
          margin-bottom: 2rem;
        }

        .section-block h3 {
          color: var(--dark);
          margin-bottom: 1rem;
          font-size: 1.3rem;
          position: relative;
          padding-bottom: 0.5rem;
        }

        .section-block h3::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 50px;
          height: 3px;
          background: var(--primary);
          border-radius: 3px;
        }

        .tour-description {
          font-size: 0.95rem;
          color: var(--dark-gray);
          line-height: 1.7;
          margin-bottom: 1.5rem;
        }

        .highlights-list, .inclusions-list, .exclusions-list {
          list-style: none;
          margin-bottom: 1.5rem;
        }

        .highlights-list li, .inclusions-list li, .exclusions-list li {
          margin-bottom: 0.8rem;
          display: flex;
          align-items: flex-start;
          gap: 0.8rem;
          font-size: 0.95rem;
          color: var(--dark-gray);
          line-height: 1.6;
        }

        .highlight-icon {
          color: var(--primary);
          margin-top: 3px;
          flex-shrink: 0;
        }

        .inclusion-icon {
          color: var(--accent);
          margin-top: 3px;
          flex-shrink: 0;
        }

        .exclusion-icon {
          color: #f56565;
          margin-top: 3px;
          flex-shrink: 0;
        }

        .no-data {
          color: var(--medium-gray);
          font-style: italic;
        }

        .inclusion-exclusion {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 2rem;
          margin-bottom: 2rem;
        }

        .inclusions, .exclusions {
          background: var(--lighter-gray);
          padding: 1.5rem;
          border-radius: 8px;
        }

        .itinerary {
          background: var(--lighter-gray);
          padding: 1.5rem;
          border-radius: 8px;
        }

        .day-plan {
          margin-bottom: 1.5rem;
        }

        .day-plan:last-child {
          margin-bottom: 0;
        }

        .day-plan h4 {
          color: var(--dark);
          margin-bottom: 0.5rem;
          font-size: 1.1rem;
        }

        .day-plan p {
          color: var(--dark-gray);
          line-height: 1.7;
          font-size: 0.95rem;
        }

        .no-itinerary {
          color: var(--medium-gray);
          font-style: italic;
        }

        .terms-conditions {
          background: var(--lighter-gray);
          padding: 1.5rem;
          border-radius: 8px;
        }

        .terms {
          font-size: 0.9rem;
          color: var(--dark-gray);
          line-height: 1.7;
        }

        /* Enquiry Form Styles */
        .enquiry-modal {
          max-width: 600px;
        }

        .enquiry-form {
          padding: 1rem 2rem 2rem;
        }

        .form-group {
          margin-bottom: 1.5rem;
        }

        .form-group label {
          display: block;
          margin-bottom: 0.5rem;
          font-weight: 600;
          color: var(--dark);
          font-size: 0.95rem;
        }

        .form-group input {
          width: 100%;
          padding: 0.8rem 1rem;
          border: 1px solid var(--light-gray);
          border-radius: 6px;
          font-size: 1rem;
          transition: var(--transition);
        }

        .form-group input:focus {
          outline: none;
          border-color: var(--primary);
          box-shadow: 0 0 0 3px rgba(74, 107, 255, 0.1);
        }

        .form-group input::placeholder {
          color: var(--medium-gray);
        }

        .read-only {
          background: var(--lighter-gray);
          color: var(--dark-gray);
          cursor: not-allowed;
        }

        .form-row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 1.5rem;
        }

        .submit-btn {
          width: 100%;
          padding: 1rem;
          background: var(--primary);
          color: white;
          border: none;
          border-radius: 6px;
          font-size: 1rem;
          font-weight: 600;
          cursor: pointer;
          transition: var(--transition);
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.5rem;
          margin-top: 1rem;
        }

        .submit-btn:hover {
          background: var(--primary-dark);
        }

        /* Responsive Styles */
        @media (max-width: 1200px) {
          .modal-content {
            grid-template-columns: 1fr;
          }
          
          .modal-price-section {
            position: static;
            margin-bottom: 2rem;
          }
          
          .inclusion-exclusion {
            grid-template-columns: 1fr;
          }
        }

        @media (max-width: 900px) {
          .cards {
            grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
          }
          
          .hero-section {
            padding: 3rem 1.5rem;
          }
          
          .title {
            font-size: 2.2rem;
          }
        }

        @media (max-width: 768px) {
          .form-row {
            grid-template-columns: 1fr;
            gap: 1rem;
          }
          
          .modal-image-gallery {
            padding: 0 1rem;
          }
          
          .main-image {
            height: 300px;
          }
          
          .modal-content {
            padding: 1.5rem;
          }
        }

        @media (max-width: 600px) {
          .modal-overlay {
            padding: 1rem;
          }
          
          .modal-header {
            padding: 1.5rem 1rem 0;
          }
          
          .thumbnail-container {
            grid-template-columns: repeat(2, 1fr);
          }
          
          .hero-section {
            padding: 2rem 1rem;
            border-radius: 0;
            margin-left: -1rem;
            margin-right: -1rem;
          }
          
          .title {
            font-size: 1.8rem;
          }
          
          .subtitle {
            font-size: 1rem;
          }
        }

        @media (max-width: 480px) {
          .cards {
            grid-template-columns: 1fr;
          }
          
          .search-box button {
            padding: 0 1.5rem;
          }
        }

        .download-pdf-btn {
          width: 100%;
          padding: 1rem;
          background: #e53e3e;
          color: white;
          border: none;
          border-radius: 6px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.5rem;
          margin-bottom: 1rem;
        }

        .download-pdf-btn:hover {
          background: #c53030;
        }

        /* ... (rest of your existing styles) ... */
      `}</style>

      <div className="container">
        <div className="hero-section">
          <div className="hero-content">
            <h1 className="title">Explore India's Hidden Gems</h1>
            <p className="subtitle">
              Discover handcrafted domestic tour packages to India's most enchanting destinations, 
              with exclusive discounts and personalized experiences
            </p>
            
            <div className="search-container">
              <div className="search-box">
                <input
                  type="text"
                  placeholder="Search packages by name or destination..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                <button>
                  <FontAwesomeIcon icon={faSearch} /> Search
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="cards-container">
          {loading ? (
            <div>
          <style>{`
         .loading-container {
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          display: flex;
          justify-content: center;
          align-items: center;
          background: linear-gradient(135deg, #7d0000ff 0%, #ab0404ff 100%);
          color: #fff;
          z-index: 9999;
          flex-direction: column;
        }

        .loader {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 16px;
        }

        .loader-spinner {
          width: 80px;
          height: 80px;
          border: 8px solid rgba(255, 255, 255, 0.2);
          border-top: 8px solid #fff;
          border-radius: 50%;
          animation: spin 1.2s linear infinite;
        }

        .loader-spinner-inner {
          width: 40px;
          height: 40px;
          border: 4px solid rgba(255, 255, 255, 0.2);
          border-top: 4px solid #ffeb3b;
          border-radius: 50%;
          margin: auto;
          margin-top: 14px;
          animation: spin-reverse 1.5s linear infinite;
        }

        .loader-text {
          font-size: 1.4rem;
          font-weight: bold;
          letter-spacing: 1px;
          margin-top: 10px;
        }

        .loader-dots {
          display: flex;
          gap: 6px;
          margin-top: 5px;
        }

        .dot {
          width: 10px;
          height: 10px;
          background: #fff;
          border-radius: 50%;
          animation: bounce 1.2s infinite ease-in-out;
        }

        .dot:nth-child(1) {
          animation-delay: 0s;
        }

        .dot:nth-child(2) {
          animation-delay: 0.2s;
        }

        .dot:nth-child(3) {
          animation-delay: 0.4s;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        @keyframes spin-reverse {
          0% { transform: rotate(360deg); }
          100% { transform: rotate(0deg); }
        }

        @keyframes bounce {
          0%, 80%, 100% {
            transform: scale(0.8);
            opacity: 0.6;
          }
          40% {
            transform: scale(1.2);
            opacity: 1;
          }
        }
      `}</style>

      <div className="loading-container">
        <div className="loader">
          <div className="loader-spinner">
            <div className="loader-spinner-inner"></div>
          </div>
          <div className="loader-text">Loading Packages</div>
          <div className="loader-dots">
            <span className="dot"></span>
            <span className="dot"></span>
            <span className="dot"></span>
          </div>
        </div>
      </div>
    </div>
    
          ) : filteredPackages.length > 0 ? (
            <div className="cards">
              {filteredPackages.map((tour) => (
                <TourCard key={tour.id} tour={tour} />
              ))}
            </div>
          ) : (
            <div className="no-results">
              <FontAwesomeIcon icon={faSearch} />
              <h3>No packages found</h3>
              <p>We couldn't find any packages matching your search. Try different keywords.</p>
            </div>
          )}
        </div>
      </div>
      
      {selectedTour && (
        <TourDetailsModal 
          tour={selectedTour} 
          onClose={() => setSelectedTour(null)} 
        />
      )}
      
      <Footer />
    </>
  );
}